import { combineReducers } from '@reduxjs/toolkit'

import { REDUCER_INDEX } from '../constants'
// eslint-disable-next-line import/no-duplicates
import { reports, stages, teams, tournament } from '../redux'
import biosecurity from './biosecurity'
import creator from './creator'
import matchBiosecurity from './matchBiosecurity'
import permissions from './permissions'
import players from './players'

const reducer = combineReducers({
  biosecurity,
  creator,
  matchBiosecurity,
  permissions,
  players,
  reports: reports.reducer,
  stages: stages.reducer,
  teams: teams.reducer,
  tournament: tournament.reducer,
})

export const registerReducer = (state) => ({
  ...state,
  [REDUCER_INDEX]: reducer,
})

export const getState = (state) => state[REDUCER_INDEX]
export const getStateBiosecurity = (state) => state[REDUCER_INDEX].biosecurity
export const getStateCreator = (state) => state[REDUCER_INDEX].creator
export const getStateMatchBiosecurity = (state) => state[REDUCER_INDEX].matchBiosecurity
export const getStatePermissions = (state) => state[REDUCER_INDEX].permissions
export const getStatePlayers = (state) => state[REDUCER_INDEX].players

export default reducer
